import { CountryCode, isSupportedCountry } from "libphonenumber-js";
import { useAppSelector } from "@/redux/hooks";
import { defaultCountrySelector } from "@/redux/slices/operator/selectors";

/** The operator's country, for reading phone numbers stored without a country code. */
export const useOperatorPhoneCountry = (): CountryCode | undefined => {
  const operatorCountry = useAppSelector(defaultCountrySelector) as CountryCode | undefined;
  return operatorCountry && isSupportedCountry(operatorCountry) ? operatorCountry : undefined;
};
